import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {SpecialPriceIcon} from "@pg-design/icons-module";
import {FormProviderRHF, RadioGroupControlled, useFormRHF} from "@pg-design/rhf-components-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {hitUserSegmentBudget} from "@pg-mono/google-tag-manager";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {OfferBoxBase} from "../../atoms/OfferBoxBase";
import {useHitSearchSubmit} from "../../search/hooks/use_hit_search_submit";
import {useSearchFormSubmit} from "../../search/hooks/use_search_form_submit";
import {SearchFormValuesType} from "../../search/types/SearchFormValuesType";
import {hitGtmFilterBudgetInBox} from "../tracking/listing_box_events";

interface IProps {
    priceVariants: number[];
}

type IFormValues = {budgetVariantRadio: string};

export const BudgetVariantRadioBox = ({priceVariants}: IProps) => {
    const offerListLatestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues) as SearchFormValuesType;
    const hitSearchSubmit = useHitSearchSubmit();

    const formMethods = useFormRHF<IFormValues>({
        defaultValues: {budgetVariantRadio: String(priceVariants[0])}
    });

    const submitSearchForm = useSearchFormSubmit({
        multiRegionLink: rpAppLink.offer.multiList,
        latestQuery: offerListLatestQuery,
        listFriendlyLink: rpAppLink.offer.listFriendly,
        abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad,
        onSearchSubmit: (formValues) => {
            hitSearchSubmit(formValues);
        }
    });

    const onSubmit = async (values: IFormValues) => {
        const priceUpper = parseInt(values.budgetVariantRadio, 10);

        const newFormValues = {
            ...searchFormValues,
            price: {lower: "", upper: priceUpper},
            instalment: ""
        };

        hitUserSegmentBudget({priceUpper: newFormValues.price?.upper, instalment: newFormValues.instalment});
        hitGtmFilterBudgetInBox(false);

        await submitSearchForm(newFormValues);
    };

    const options = priceVariants.map((threshold) => ({
        value: String(threshold),
        labelContent: `do ${threshold / 1000} tys`
    }));

    return (
        <OfferBoxBase className={offerBoxStyle}>
            <FormProviderRHF {...formMethods}>
                <form onSubmit={formMethods.handleSubmit(onSubmit)} className={formStyle}>
                    <div className={headerStyle}>
                        <SpecialPriceIcon size="3.2" wrapperSize="4.8" wrapperColor={getThemeVariable("colors.primary")} />

                        <Text as="p" variant="headline_5" align="center">
                            Podaj swój budżet, aby zobaczyć lepiej dopasowane oferty
                        </Text>
                    </div>

                    <RadioGroupControlled name="budgetVariantRadio" options={options} className={radioGroupStyle} optionClassName={radioOptionStyle} />

                    <Button className={submitButtonStyle} variant="outlined_secondary" type="submit">
                        Wybierz
                    </Button>
                </form>
            </FormProviderRHF>
        </OfferBoxBase>
    );
};

const formStyle = css({
    height: "100%",
    width: "100%",
    paddingX: 3,
    paddingY: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "column"
});

const offerBoxStyle = css({
    minHeight: "450px"
});

const headerStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: 2
});

const radioGroupStyle = css({
    display: "flex",
    flexDirection: "column",
    width: "fit-content",
    alignItems: "flex-start",
    gap: 1.5
});

const radioOptionStyle = css({
    flex: "none"
});

const submitButtonStyle = css({
    width: "100%"
});
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {SpecialPriceIcon} from "@pg-design/icons-module";
import {FormProviderRHF, RadioGroupControlled, useFormRHF} from "@pg-design/rhf-components-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {hitUserSegmentBudget} from "@pg-mono/google-tag-manager";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {OfferBoxBase} from "../../atoms/OfferBoxBase";
import {useHitSearchSubmit} from "../../search/hooks/use_hit_search_submit";
import {useSearchFormSubmit} from "../../search/hooks/use_search_form_submit";
import {SearchFormValuesType} from "../../search/types/SearchFormValuesType";
import {hitGtmFilterBudgetInBox} from "../tracking/listing_box_events";

interface IProps {
    priceVariants: number[];
}

type IFormValues = {budgetVariantRadio: string};

export const BudgetVariantRadioBox = ({priceVariants}: IProps) => {
    const offerListLatestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues) as SearchFormValuesType;
    const hitSearchSubmit = useHitSearchSubmit();

    const formMethods = useFormRHF<IFormValues>({
        defaultValues: {budgetVariantRadio: String(priceVariants[0])}
    });

    const submitSearchForm = useSearchFormSubmit({
        multiRegionLink: rpAppLink.offer.multiList,
        latestQuery: offerListLatestQuery,
        listFriendlyLink: rpAppLink.offer.listFriendly,
        abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad,
        onSearchSubmit: (formValues) => {
            hitSearchSubmit(formValues);
        }
    });

    const onSubmit = async (values: IFormValues) => {
        const priceUpper = parseInt(values.budgetVariantRadio, 10);

        const newFormValues = {
            ...searchFormValues,
            price: {lower: "", upper: priceUpper},
            instalment: ""
        };

        hitUserSegmentBudget({priceUpper: newFormValues.price?.upper, instalment: newFormValues.instalment});
        hitGtmFilterBudgetInBox(false);

        await submitSearchForm(newFormValues);
    };

    const options = priceVariants.map((threshold) => ({
        value: String(threshold),
        labelContent: `do ${threshold / 1000} tys`
    }));

    return (
        <OfferBoxBase className={offerBoxStyle}>
            <FormProviderRHF {...formMethods}>
                <form onSubmit={formMethods.handleSubmit(onSubmit)} className={formStyle}>
                    <div className={headerStyle}>
                        <SpecialPriceIcon size="3.2" wrapperSize="4.8" wrapperColor={getThemeVariable("colors.primary")} />

                        <Text as="p" variant="headline_5" align="center">
                            Podaj swój budżet, aby zobaczyć lepiej dopasowane oferty
                        </Text>
                    </div>

                    <RadioGroupControlled name="budgetVariantRadio" options={options} className={radioGroupStyle} optionClassName={radioOptionStyle} />

                    <Button className={submitButtonStyle} variant="outlined_secondary" type="submit">
                        Wybierz
                    </Button>
                </form>
            </FormProviderRHF>
        </OfferBoxBase>
    );
};

const formStyle = css({
    height: "100%",
    width: "100%",
    paddingX: 3,
    paddingY: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "column"
});

const offerBoxStyle = css({
    minHeight: "450px"
});

const headerStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: 2
});

const radioGroupStyle = css({
    display: "flex",
    flexDirection: "column",
    width: "fit-content",
    alignItems: "flex-start",
    gap: 1.5
});

const radioOptionStyle = css({
    flex: "none"
});

const submitButtonStyle = css({
    width: "100%"
});
